var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      staticClass: "avatar-crop"
    },
    [
      _vm.dataUrl
        ? [
            _vm.pickerWidth && _vm.pickerHeight
              ? _c("image-picker", {
                  ref: "imagePicker",
                  staticClass: "image-picker",
                  attrs: {
                    width: _vm.pickerWidth,
                    height: _vm.pickerHeight,
                    maxLeft: this.avatarLeft,
                    maxTop: this.avatarTop,
                    avatarWidth: this.width,
                    avatarHeight: this.height,
                    src: _vm.dataUrl
                  }
                })
              : _vm._e(),
            _vm._v(" "),
            _c("div", {
              staticClass: "avatar-shutter",
              style: {
                width: this.width + "px",
                height: this.height + "px",
                top: this.avatarTop + "px",
                left: this.avatarLeft + "px"
              }
            })
          ]
        : _c("loading"),
      _vm._v(" "),
      _c("i", { staticClass: "icon icon-close", on: { click: _vm.$_cancel } }),
      _vm._v(" "),
      _vm.dataUrl
        ? _c("i", {
            staticClass: "icon icon-check",
            on: { click: _vm.$_createAvatar }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2150e119", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2150e119","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/avatar-crop/avatar-crop.vue
// module id = 125
// module chunks = 0